module.exports = __webpack_public_path__ + "img/pic_ewm@2x.47ea2c20.png";